export default "__VITE_ASSET__C8sk$NYG__"